import React, { FC } from "react";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const SolidInfoCircle: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faInfoCircle} {...props} />
);
